import { jsx as _jsx } from "react/jsx-runtime";
import useImage from "../../../../../base/multimedia/image/useImage.js";
import Masonry from "../../../../../common/others/masonry/views/desktop/index.js";
import { masonryCarouselMarketingConverter } from "../../../../../../helpers/wrappers/marketing/masonry-carousel/desktop/converter.js";
import * as S from "./styled.js";
export const MasonryCarouselMarketingDesktop = (props)=>{
    const masonryCarousel = masonryCarouselMarketingConverter(props);
    const { imageUrl  } = props.props ?? props.data ?? {};
    const backgroundUri = useImage(imageUrl);
    return /*#__PURE__*/ _jsx(S.MasonryCarouselWrapper, {
        "data-testid": "MasonryCarouselDesktop",
        $backgroundImage: backgroundUri,
        children: /*#__PURE__*/ _jsx(Masonry, {
            ...masonryCarousel
        })
    });
};
export default MasonryCarouselMarketingDesktop;

//# sourceMappingURL=index.js.map